import { familyLifeStyleVariantCollection } from '@/components/CharacterGenerator/constants/familyLifeStyleVariantList'

export default (character) => {
  const { familyLifeStyleId } = character

  return `Образ жизни семьи: ${familyLifeStyleVariantCollection[familyLifeStyleId].name}`
}
